<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">Transplante</div>
      </unicom-coluna>
    </unicom-linha>

    <unicom-linha style="margin-bottom: 24px">
      <unicom-coluna sm="4" :class="espacamentoMobile">
        <div align="right">Realiza Transplante?</div>
      </unicom-coluna>
      <unicom-coluna sm="1" :class="espacamentoMobile">
        <unicom-switch
          :value="clickSwitch.transplante"
          @input="toggleSwitch('transplante')"
        />
      </unicom-coluna>

      <unicom-coluna sm="3" :class="espacamentoMobile">
        <Multiselect
          v-model="transplantes"
          :propsMultiselect="{
            placeholder: 'Tipo de Transplante *',
            options: listaTransplantes,
            'track-by': 'id',
            label: 'tipoTransplante'
          }"
          :errorMessage="mensagemDeErro.transplantes"
          v-if="clickSwitch.transplante"
        />
      </unicom-coluna>

      <unicom-coluna
        sm="1"
        :class="espacamentoMobile"
        v-if="outrosTransplantes && clickSwitch.transplante"
      >
        <div align="right" style="font-size: 17px; padding-top: 8px">
          Outros:
        </div>
      </unicom-coluna>
      <unicom-coluna
        sm="3"
        :class="espacamentoMobile"
        v-if="outrosTransplantes && clickSwitch.transplante"
      >
        <custom-campo-texto
          v-model="campoOutrosTranplantes"
          :maxCaracteres="1500"
          :icone="campoOutrosTranplantes ? 'x' : ''"
          :mensagemErro="errors.campoOutrosTranplantes"
          @click-icone="campoOutrosTranplantes = ''"
          @input="validate('campoOutrosTranplantes')"
          colorPlaceholder="#9E9E9E"
          placeholder="Outros Transplantes"
          ladoIcone="direito"
          clickIcone
        />
      </unicom-coluna>
    </unicom-linha>
  </unicom-layout-cartao>
</template>

<script>
import TransplanteMixin from "@/views/RecursosPropriosQuestionarios/shared/mixins/questionarios/TransplanteMixin";
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

export default {
  mixins: [TransplanteMixin],
  components: {
    Multiselect,
    CustomCampoTexto
  },
  data() {
    return {};
  },
  methods: {
    toggleSwitch(campo) {
      return (this.clickSwitch[campo] = !this.clickSwitch[campo]);
    }
  },
  computed: {
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {}
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
